import ConstrainBase from "../ConstrainBase";
import ValidationResult from "../ValidationResult";

/**
 * class NotBlankEnumConstrain
 * Stellt sicher dass ein Enum-Wert ausgewählt wurde (nicht leer, nicht 0).
 * analog zur serverseitigen NotBlankEnumConstrain.php
 */
class NotBlankEnumConstrain extends ConstrainBase {

  validate(value) {
    if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
      return new ValidationResult(false, 'Bitte einen Wert auswählen.');
    }
    return new ValidationResult(true, '');
  }
}

export default NotBlankEnumConstrain;
